import React, {FormEvent, useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {logIn} from "../../api/auth-api";
import Form from "react-bootstrap/Form";
import {Alert, Button} from "react-bootstrap";
import {useAuth} from "../../common/AuthProvider";
import {Page} from "../../common/Page";

export interface UserResponse {
  userId: string,
  email: string,
  displayName: string
}


export const LoginPage = () => {
  const navigate = useNavigate();
  const {setIsLoggedIn} = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<boolean>(false);
  const passwordField = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError(false);
    setSubmitting(true);
    logIn({email, password})
      .then(() => setIsLoggedIn(true))
      .then(() => navigate("/"))
      .catch(() => {
        setError(true);
        setSubmitting(false);
      });
  };

  useEffect(() => {
    if (error) {
      passwordField.current?.focus();
      passwordField.current?.select();
    }
  }, [error]);

  return <Page title={"Log in"}>
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="login.email">
        <Form.Label>Email address</Form.Label>
        <Form.Control type="email"
                      placeholder="name@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={submitting}
                      autoFocus={true}
                      required={true}
        />
      </Form.Group>
      <Form.Group className="mb-3" controlId="login.password">
        <Form.Label>Password</Form.Label>
        <Form.Control ref={passwordField}
                      type="password"
                      placeholder=""
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      disabled={submitting}
                      required={true}
        />
      </Form.Group>
      <Button type={'submit'} variant={'primary'} className={'mb-3'} disabled={submitting}>Log in</Button>
      {error && <Alert variant={"danger"} className={'mb-3'}>
        <Alert.Heading>Log-in failed</Alert.Heading>
        <p>Make sure your email and password are correct.</p>
      </Alert>}
    </Form>
    <p>Forgot your password? <a href={'/reset-password'}>Reset your password</a></p>
  </Page>;
}